import { distanceFromMillimeters } from "./distance.ts";

const frameBorderSize = distanceFromMillimeters(24);
const frameArtOverlap = distanceFromMillimeters(8);

export { frameBorderSize, frameArtOverlap };
